// extracted by mini-css-extract-plugin
module.exports = {"root":"Radiogroup_root__2kPRB","disabled":"Radiogroup_disabled__htDTn","title":"Radiogroup_title__R7Ux_","radiobutton":"Radiogroup_radiobutton__2vKrd"};